/* eslint-disable no-unused-vars */
import React, { useState, useCallback, useMemo, useEffect } from 'react';

import style from './style.module.scss';
import FilterHeader from '@components/filters/filter-header';
import SiteListingInner from '@components/site-listing-inner';
import VirtualList from '@components/virtual-list/virtual-list';
import { useDispatch } from 'react-redux';
import { siteMapActions } from '@redux/slices/site-map';

const VirtualListInModal = ({
  open,
  list,
  assetDetailsSiteLists,
  equipmentListingScrollEvent,
  isHidden,
  searched,
  from,
  selectedSiteIdForMapView,
  height,
  width,
  isFilterActive,
  openMenuTabIsActive = false
}) => {
  const dispatch = useDispatch();

  const [initialY, setInitialY] = useState(null);
  const [direction, setDirection] = useState('mouseIsPullingDown');

  useEffect(() => {
    // isFilterActive ||
    if (openMenuTabIsActive && direction === 'mouseIsPullingUp') {
      setDirection('mouseIsPullingDown');

      removeStyleAttributeFromContainer();
      // dispatch?.(
      //   siteMapActions.setSelectedSiteIdOnMapView({
      //     siteId: null,
      //     siteIndex: -1
      //   })
      // );
    }
  }, [isFilterActive, direction, dispatch, openMenuTabIsActive]);

  useEffect(() => {
    if (direction === 'mouseIsPullingUp' && list?.length === 0) {
      setDirection('mouseIsPullingDown');
      removeStyleAttributeFromContainer();
    }
  }, [list, direction]);

  const handleTouchStart = (e) => {
    setInitialY(e.touches[0].clientY);
    setDirection('mouseIsPullingDown');

    // dispatch?.(
    //   siteMapActions.setSelectedSiteIdOnMapView({
    //     siteId: null,
    //     siteIndex: -1
    //   })
    // );
    removeStyleAttributeFromContainer();
  };

  const handleTouchMove = (e) => {
    if (initialY !== null) {
      const currentY = e.touches[0].clientY;
      if (currentY > initialY) {
        setDirection('mouseIsPullingDown');
        // dispatch?.(
        //   siteMapActions.setSelectedSiteIdOnMapView({
        //     siteId: null,
        //     siteIndex: -1
        //   })
        // );
        removeStyleAttributeFromContainer();
      } else {
        setDirection('mouseIsPullingUp');
      }
    }
  };

  const handleTouchEnd = () => {
    setInitialY(null);
  };

  useEffect(() => {
    if (list?.length > 0 && open) {
      if (selectedSiteIdForMapView?.siteId) {
        const item = document.querySelector('[data-index="0"]');
        const selectedCardHeight = item?.clientHeight || 0;

        console.log({ selectedCardHeight });

        const virtualListModalContainer = document.getElementById('virtual-list-modal-container');
        const virtualListModalContainer1 = document.getElementById('react-swipeable-virtual-list');
        if (virtualListModalContainer1) {
          virtualListModalContainer1.scrollTo(0, 0);
          virtualListModalContainer1.scrollIntoView({ behavior: 'smooth' });
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
          });
        }

        const listContainer = document.getElementById('list-container');
        if (virtualListModalContainer && listContainer) {
          if (width < 1025 && width >= 768) {
            console.log({ selectedCardHeight });
            virtualListModalContainer.style.top = `calc(100svh - ${77 + selectedCardHeight}px)`;
            let xoo = height - (selectedCardHeight + 171);
            listContainer.style.height = `calc(100svh - ${xoo + 171}px)`;
          } else if (width <= 767) {
            virtualListModalContainer.style.top = `calc(100svh - ${159 + selectedCardHeight}px)`;
            let xoo = height - (selectedCardHeight + 297);
            listContainer.style.height = `calc(100svh - ${xoo + 297}px)`;
          }
        }
      }
    }
  }, [selectedSiteIdForMapView?.siteId, list, open, height]);

  useEffect(() => {
    const virtualListModalContainer = document.getElementById('virtual-list-modal-container');
    const listContainer = document.getElementById('list-container');

    if (virtualListModalContainer && listContainer) {
      if (direction === 'mouseIsPullingUp') {
        !selectedSiteIdForMapView?.siteId && virtualListModalContainer.removeAttribute('style');
        !selectedSiteIdForMapView?.siteId && listContainer.removeAttribute('style');
      } else if (direction === 'mouseIsPullingDown') {
        if (!selectedSiteIdForMapView?.siteId) {
          virtualListModalContainer.removeAttribute('style');
          listContainer.removeAttribute('style');
        }
      }
    }
  }, [direction, selectedSiteIdForMapView?.siteId]);

  const onClickDirectionIconEvent = () => {
    let _direction = direction;

    _direction = _direction === 'mouseIsPullingDown' ? 'mouseIsPullingUp' : 'mouseIsPullingDown';

    if (_direction === 'mouseIsPullingDown') {
      // dispatch?.(
      //   siteMapActions.setSelectedSiteIdOnMapView({
      //     siteId: null,
      //     siteIndex: -1
      //   })
      // );
      removeStyleAttributeFromContainer();
    }
    setDirection(_direction);
  };

  const removeStyleAttributeFromContainer = () => {
    const virtualListModalContainer = document.getElementById('virtual-list-modal-container');
    const listContainer = document.getElementById('list-container');
    if (virtualListModalContainer && listContainer) {
      virtualListModalContainer.removeAttribute('style');
      listContainer.removeAttribute('style');
    }
  };

  return (
    <div
      className={`${style.container} ${open && style.open} ${
        open && direction === 'mouseIsPullingUp' && style.up
      } ${open && direction === 'mouseIsPullingDown' && style.down} ${
        width < 1025 && width > 767
          ? isFilterActive
            ? style.isFilterActiveWidthOnTablet
            : style.isFilterInActiveWidthOnTablet
          : style.widthOnSmallScreen
      }  `}
      id="virtual-list-modal-container"
    >
      <div className={style.containerSection}>
        <div
          style={{ marginBottom: '16px' }}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
          onClick={() => onClickDirectionIconEvent()}
        >
          <FilterHeader
            title="View list"
            siteListingWhenMapsIsOpenOnTabletScreen={width < 1025 && width > 767 ? true : false}
            mapView={true}
          />
        </div>

        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <div
            style={{
              width: '100%',
              borderTop: '1px solid rgb(203, 210, 217)'
            }}
          />
        </div>

        <div id="list-container" className={style.listContainer} data-hello="yellow">
          <VirtualList
            data={list}
            divider={true}
            siteListingPage
            component={SiteListingInner}
            onScrollEvent={assetDetailsSiteLists ? equipmentListingScrollEvent : null}
            isHidden={isHidden}
            componentProps={{
              highlight: searched,
              highlightName: true,
              from,
              noLink: true
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default VirtualListInModal;
